import { render, staticRenderFns } from "./ContractHistory.vue?vue&type=template&id=fa3a9458"
import script from "./ContractHistory.vue?vue&type=script&lang=js"
export * from "./ContractHistory.vue?vue&type=script&lang=js"
import style0 from "./ContractHistory.vue?vue&type=style&index=0&id=fa3a9458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports